import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportIncidentComponent } from './components/reportincident.component';

const routes: Routes = [
  { path: '', component: ReportIncidentComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})

export class ReportIncidentRoutingModule { }
